var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpiryTimer = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6814 4.97358L15.8926 3.76243L17.0711 4.94094L15.8599 6.15209C16.8863 7.43515 17.5 9.06266 17.5 10.8335C17.5 14.9757 14.1422 18.3335 10 18.3335C5.85787 18.3335 2.5 14.9757 2.5 10.8335C2.5 6.69136 5.85787 3.3335 10 3.3335C11.7708 3.3335 13.3983 3.94722 14.6814 4.97358ZM10 16.6668C13.2217 16.6668 15.8333 14.0552 15.8333 10.8335C15.8333 7.61184 13.2217 5.00016 10 5.00016C6.77834 5.00016 4.16667 7.61184 4.16667 10.8335C4.16667 14.0552 6.77834 16.6668 10 16.6668ZM9.16667 6.66683H10.8333V11.6668H9.16667V6.66683ZM6.66667 0.833496H13.3333V2.50016H6.66667V0.833496Z",
    fill: "#AB572F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpiryTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExpiryTimer.a7e0d246.svg";
export { ForwardRef as ReactComponent };